
import request from '@/utils/request'
export function pageOrderList(query) {
  return request({
    url: '/shop/shop-order-goods/list',
    method: 'get',
    params: query
  })
}